<template>
  <div class="singleAnalysis">
    <el-row class="header-row">
      <span class="sample-title">{{removeLables(title)}}(ID: {{surveyId}})</span>
    </el-row>
    <el-row class="header-row">
      <el-col :span="9">
        <span>选择时间</span>
        <el-date-picker
          v-model="dataRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="datePickerOptions"
          @change="getAnswerInfos"
          size="small"
        ></el-date-picker>
      </el-col>
      <el-col :span="5" style="visibility: hidden">
        <span>数据类型</span>
        <el-select v-model="dataType" size="small" @change="getAnswerInfos" class="page-dataType">
          <el-option
            v-for="(item, index) in dataTypeOptions"
            :label="item.label"
            :value="item.value"
            :key="index"
            v-if="item.value !== 'incomplete' && item.value !== 'deleted'"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <span>显示类型</span>
        <el-select v-model="showDataType" size="small" class="dataTypeShow">
          <el-option
            v-for="(item, idx) in showDataTypeOption"
            :label="item.label"
            :value="item.value"
            :key="idx"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <div class="pull-right">
          <el-button type="text" v-if="role!=2" @click="handleExport">导出分析结果</el-button>
          <el-button type="text" v-else :disabled="true" @click="handleExport">导出分析结果</el-button>
          <span>|</span>
          <el-button type="text" @click="showDialogFilter = true">编辑筛选条件</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="tab-pages">
      <div v-if="filterArr.length > 0 && filterStr" class="terms-disp">
        <span>
          <b>筛选条件</b>(
          <el-button type="text" @click="showDialogFilter = true">修改</el-button>)
        </span>
        <p
          v-if="term.ques.id"
          v-for="(term, i) in filterArr"
          :key="i"
        >{{removeLables(term.ques.title) + ' ' + (term.operator == '1' ? '不包含' : "包含") + ' ' + getOptText(term.ques, term.optId)}}</p>
        <el-button
          class="clean-terms-clear"
          icon="el-icon-delete"
          type="text"
          @click="handleClear"
        >清空</el-button>
      </div>
      <el-tabs
        v-if="answerSurvey.answerPages.length > 0"
        v-model="activePage"
        class="tab-page"
        type="card"
      >
        <el-tab-pane
          :key="item.index"
          v-for="(item, idx) in answerSurvey.answerPages"
          :label="'第' + (idx + 1) + '页'"
          :name="idx + 1 + ''"
        >
          <div
            class="single-analysis-item"
            :key="i"
            v-for="(ques, i) in item.answerQuestionList"
            v-if="ques.type !== 'description'"
          >
            <p class="singleAnalysisTitle">{{(ques.index + 1) + '.' + removeLables(ques.title)}}</p>
            <radio-chart :quesInfo="ques" :showChart="showChart" v-if="ques.type == 'radio'"></radio-chart>
            <checkbox-chart :quesInfo="ques" :showChart="showChart" v-if="ques.type == 'checkbox'"></checkbox-chart>
            <star-chart :quesInfo="ques" :showChart="showChart" v-if="ques.type == 'star'"></star-chart>
            <select-chart :quesInfo="ques" :showChart="showChart" v-if="ques.type == 'select'"></select-chart>
            <sort-chart :quesInfo="ques" :showChart="showChart" v-if="ques.type == 'sort'"></sort-chart>
            <textarea-chart :quesInfo="ques" v-if="ques.type == 'textarea'"></textarea-chart>
            <date-chart :quesInfo="ques" v-if="ques.type == 'date'"></date-chart>
            <region-chart :quesInfo="ques" v-if="ques.type == 'region'"></region-chart>
            <upload-chart :quesInfo="ques" v-if="ques.type == 'upload'"></upload-chart>
            <matrix-radio-chart
              :quesInfo="ques"
              :showChart="showChart"
              v-if="ques.type == 'matrixRadio'"
            ></matrix-radio-chart>
            <matrix-checkbox-chart
              :quesInfo="ques"
              :showChart="showChart"
              v-if="ques.type == 'matrixCheckbox'"
            ></matrix-checkbox-chart>
            <matrix-star-chart
              :quesInfo="ques"
              :showChart="showChart"
              v-if="ques.type == 'matrixStar'"
            ></matrix-star-chart>
            <text-multiple-chart :quesInfo="ques" v-if="ques.type == 'textMultiple'"></text-multiple-chart>
            <chained-select-chart :quesInfo="ques" v-if="ques.type == 'chainedSelects'"></chained-select-chart>
          </div>
          <p v-if="item.answerQuestionList.length === 0" style="text-align: center;">该页没有题目</p>
        </el-tab-pane>
      </el-tabs>
      <p v-else align="center">暂无符合清洗条件的数据</p>
    </div>
    <el-dialog title="筛选条件" :visible.sync="showDialogFilter">
      <div class="filter-item" v-for="(term, i) in filterArr" :key="i">
        <el-select
          v-model="term.quesId"
          @change="(val) => {handleTermType(val, term)}"
          placeholder="请选择题目"
        >
          <el-option
            v-for="item in allQues"
            :key="item.index"
            :label="(item.index + 1) + '.' + removeLables(item.title)"
            :disabled="item.type != 'radio' && item.type != 'checkbox' && item.type != 'select' && item.type != 'star'"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select class="operator-selector" v-model="term.operator" placeholder="请选择逻辑">
          <el-option label="包含" :value="0"></el-option>
          <el-option label="不包含" :value="1"></el-option>
        </el-select>
        <el-select v-if="term.ques.options" v-model="term.optId" placeholder="请选择选项">
          <el-option
            v-for="(item, i) in term.ques.options"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select v-else v-model="term.optId" placeholder="请选择选项">
          <el-option
            v-for="i in term.ques.starNum"
            :key="term.ques.starBeginNum + i - 1"
            :label="term.ques.starBeginNum + i - 1"
            :value="term.ques.starBeginNum + i - 1"
          ></el-option>
        </el-select>
        <el-button type="text" @click="handleDelTerm(i)">删除</el-button>
        <el-button type="text" v-if="i == filterArr.length - 1" @click="handleAddTerm">添加</el-button>
      </div>
      <el-button type="text" v-if="filterArr.length == 0" @click="handleAddTerm">添加</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogFilter = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmFilter">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { dataTypeMixin, messageMixin } from "../utils/mixins.js";
import { timeToLocal } from "../utils/utils";
import http from "../utils/http";
import {
  radioChart,
  checkboxChart,
  selectChart,
  starChart,
  textareaChart,
  matrixRadioChart,
  sortChart,
  matrixCheckboxChart,
  matrixStarChart,
  uploadChart,
  textMultipleChart,
  chainedSelectChart,
  dateChart,
  regionChart
} from "./singleAnalysis/index.js";
import { mapGetters } from "vuex";
import { DOMAIN } from '../utils/api'
export default {
  name: "singleAnalysis",
  mixins: [dataTypeMixin, messageMixin],
  data() {
    return {
      interface: {
        answerInfos: `/stat/singleAnalysis`,
        getSurvey: `/survey/get`,
        export: `${DOMAIN}/stat/exportAnalysis`,
        overview: `/exam/overview`
      },
      surveyId: null,
      title: "",
      showDataType: "1",
      showDataTypeOption: [
        {
          label: "显示全部",
          value: "1"
        },
        {
          label: "只显示表",
          value: "2"
        }
      ],
      survey: {
        pages: []
      },
      answerSurvey: {
        answerPages: []
      },
      activePage: "1",
      showDialogFilter: false,
      filterArr: [
        {
          quesId: "",
          operator: null,
          optId: "",
          ques: {}
        }
      ],
      filterStr: ""
    };
  },
  computed: {
    allQues() {
      let _quesArr = [];
      this.survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          if (ques.type !== "description") _quesArr.push(ques);
        });
      });
      return _quesArr;
    },
    showChart() {
      return this.showDataType === "1";
    },
    ...mapGetters(["role"])
  },
  components: {
    radioChart,
    checkboxChart,
    starChart,
    selectChart,
    textareaChart,
    matrixRadioChart,
    sortChart,
    matrixCheckboxChart,
    matrixStarChart,
    uploadChart,
    textMultipleChart,
    chainedSelectChart,
    dateChart,
    regionChart
  },
  mounted() {
    let { id, title = "" } = this.$route.query;
    this.surveyId = id;
    this.title = title;
    this.filterStr = localStorage.getItem("filterStr") || "";
    if (localStorage.getItem("filterArr")) {
      this.filterArr = JSON.parse(localStorage.getItem("filterArr"));
    }
    this.getAnswerInfos();
    if (this.role != 2) {
      this.getSurvey();
    }
  },
  methods: {
    getSurvey() {
      http
        .get(this.interface.getSurvey, {
          surveyId: this.surveyId
        })
        .then(response => {
          let { code, data, message } = response;
          if (code === 1) {
            this.survey = data;
          } else {
            this.showError(message);
          }
        })
        .catch(error => {
          this.showError(error);
        });
    },
    getAnswerInfos() {
      http
        .post(this.interface.answerInfos, {
          surveyId: this.surveyId,
          startTime: this.dataRange
            ? timeToLocal(this.dataRange[0]).date + " 00:00:00"
            : "",
          endTime: this.dataRange
            ? timeToLocal(this.dataRange[1]).date + " 23:59:59"
            : "",
          filter: this.filterStr || null,
          dataType: this.dataType === "complete" ? 0 : 1
        })
        .then(response => {
          let { code, data, message } = response;
          if (code === 1) {
            this.answerSurvey = data;
            this.showSuccess(message);
          } else {
            this.showError(message);
          }
        })
        .catch(error => {
          this.showError(error);
        });
    },
    handleExport() {
      let param = encodeURI(
        "surveyId=" +
          this.surveyId +
          "&startTime=" +
          (this.dataRange
            ? timeToLocal(this.dataRange[0]).date + " 00:00:00"
            : "") +
          "&endTime=" +
          (this.dataRange
            ? timeToLocal(this.dataRange[1]).date + " 23:59:59"
            : "") +
          "&filter=" +
          this.filterStr
      );
      window.open(this.interface.export + "?" + param);
    },
    removeLables(html) {
      return html.replace(/<\/?.+?>/g, "");
    },
    handleTermType(value, term) {
      for (let i = 0; i < this.allQues.length; i++) {
        if (this.allQues[i].id === value) {
          term.ques = this.allQues[i];
          break;
        }
      }
      term.operator = null;
      term.optId = null;
    },
    handleAddTerm() {
      this.filterArr.push({
        quesId: "",
        operator: null,
        optId: "",
        ques: {}
      });
    },
    handleDelTerm(i) {
      this.filterArr.splice(i, 1);
    },
    handleClear() {
      this.filterArr = [
        {
          quesId: "",
          operator: null,
          optId: "",
          ques: {}
        }
      ];
      this.filterStr = "";
      localStorage.setItem("filterStr", "");
      localStorage.setItem("filterArr", "");
      this.getAnswerInfos();
    },
    handleConfirmFilter() {
      let _filter = [];
      let _flag = false;
      this.filterArr.forEach(val => {
        let _str = "";
        if (!val.quesId || typeof val.operator !== "number" || !val.optId) {
          _flag = true;
          return false;
        }
        _str += "type_" + val.ques.type + "^";
        _str += "qId_" + val.quesId + "^";
        _str += "oId_" + val.optId + "^";
        _str += "logic_" + val.operator;
        _filter.push(_str);
      });
      if (!_flag) {
        this.filterStr = _filter.join();
        localStorage.setItem("filterStr", this.filterStr);
        localStorage.setItem("filterArr", JSON.stringify(this.filterArr));
        this.showDialogFilter = false;
        this.getAnswerInfos();
      } else {
        this.showError("配置错误");
      }
    },
    getOptText(ques, oid) {
      if (ques.type === "star") {
        return oid;
      } else {
        for (let i = 0; i < ques.options.length; i++) {
          if (ques.options[i].id === oid) return ques.options[i].text;
        }
      }
    }
  }
};
</script>
<style lang="scss">
div.singleAnalysis {
  padding: 25px;
  height: 100%;
  background-color: #fff;
  color: #999;
  border: 1px solid #e7e7e7;
  overflow-y: auto;
  .sample-title {
    color: #333;
  }
  .header-row {
    .page-dataType {
      width: 130px;
    }
    .dataTypeShow {
      width: 100px;
    }
  }
  .el-date-editor {
    width: 280px;
  }
  .el-range-separator {
    width: 10%;
  }
  .single-analysis-item {
    margin-bottom: 60px;
  }
  .singleAnalysisTitle {
    margin: 15px 0;
    color: #333;
  }
  .vue-highcharts {
    box-shadow: none;
    border: 0;
    margin-top: 20px;
  }
  .tab-page {
    min-height: 300px;
  }
  .filter-item {
    margin-bottom: 15px;
    .el-select {
      width: 155px;
      margin-right: 10px;
    }
  }
  .terms-disp {
    background-color: #f5f5f5;
    padding: 0 15px 12px;
    width: 100%;
    margin-bottom: 15px;
    color: #666;
    overflow: hidden;
    position: relative;
  }
  .clean-terms-clear {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/singleAnalysis.vue